import React from 'react'
import { ContactLinks } from './ContactLinks'
import { getContactInfoArray } from './GetContactInfoArray'

export const ContactLinksList: React.SFC<{
  emailFirst?: boolean
  light?: boolean
  productCode?: string
}> = ({ emailFirst, light, productCode }) => {
  const contacts = getContactInfoArray()
  return (
    <>
      {contacts.map((contact, index) => (
        <>
          {(productCode === contact.product || productCode === undefined) && (
            <ContactLinks {...contact} emailFirst={emailFirst} light={light} key={index} />
          )}
        </>
      ))}
    </>
  )
}
